// extracted by mini-css-extract-plugin
export default {"column":"ColumnElement_column__8IlOh","columnInner":"ColumnElement_columnInner__gHq6E","colResizeHandle":"ColumnElement_colResizeHandle__F-WYp"};